import {isDevMode} from '@angular/core';
import {Action, ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import * as fromLoadingState from './entities/shared/loading-state/loading-state.reducer'
import * as fromStoreItem from './entities/store-item/store-item.reducer';
import * as fromUser from './entities/uaa/user/user.reducer';
import * as fromInstitution from './entities/uaa/institution/institution.reducer';


export interface AppState {
  [fromStoreItem.storeItemsFeatureKey]: fromStoreItem.State
  [fromLoadingState.loadingStatesFeatureKey]: fromLoadingState.State,
  [fromUser.usersFeatureKey]: fromUser.State,
  [fromInstitution.institutionsFeatureKey]: fromInstitution.State,
}

export const reducers: ActionReducerMap<AppState> = {
  [fromStoreItem.storeItemsFeatureKey]: fromStoreItem.reducer,
  [fromLoadingState.loadingStatesFeatureKey]: fromLoadingState.reducer,
  [fromUser.usersFeatureKey]: fromUser.reducer,
  [fromInstitution.institutionsFeatureKey]: fromInstitution.reducer,
};

export function clearState(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state: AppState, action: Action): AppState => {
    if (action.type === '[User/API] Logout') {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = isDevMode() ? [clearState] : [];

export const appState = (state: AppState) => state;

